import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import Loading from "../../../components/Loading/Loading";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import LaddersDataService from "../../../services/LaddersService";
import "./ParentLadder.scss";
import useParentChildNotificationCount from "../../../hooks/useParentChildNotificationCount";

// Import Advert component for Google ads
import Advert from "../../../components/Advert/Advert";

// Import check/uncheck icons
import checkIcon from "../../../assets/images/checkUnchek/check.png";
import unCheckIcon from "../../../assets/images/checkUnchek/unCheck.png";

const ParentLadder = () => {
  const lang = useSelector((state) => state.LanguageReducer.current) || 'en';
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [checkListObj, setCheckListObj] = useState({});
  const [studentId, setStudentId] = useState("");
  const [, setTagline] = useState("");
  useParentChildNotificationCount({ autoRefresh: false });

  const labels = {
    en: {
      collegeChecklist: 'College Checklist',
      selectYourChild: 'Select Your Child',
      collegeEnrollmentLadders: 'College Enrollment Ladders Checklist',
      completeFafsa: 'Complete FAFSA',
      providedRecommendations: 'Provided Recommendations',
      completedCollegeEssay: 'Completed College Essay',
      submittedTranscript: 'Submitted Transcript',
      paidApplicationFees: 'Paid Application Fees',
      checked: 'Checked',
      unchecked: 'Unchecked'
    },
    es: {
      collegeChecklist: 'Checklist Universitaria',
      selectYourChild: 'Selecciona a tu hijo',
      collegeEnrollmentLadders: 'Lista de Verificación de Escaleras de Inscripción Universitaria',
      completeFafsa: 'Completar FAFSA',
      providedRecommendations: 'Recomendaciones Proporcionadas',
      completedCollegeEssay: 'Ensayo Universitario Completado',
      submittedTranscript: 'Expediente Académico Enviado',
      paidApplicationFees: 'Tarifas de Solicitud Pagadas',
      checked: 'Marcado',
      unchecked: 'Sin marcar'
    }
  };
  const t = (key) => (labels[lang] || labels.en)[key];

  useEffect(() => {
    getStudentList();
  }, []);

  const getStudentList = () => {
    setLoading(true);
    LaddersDataService.getParentRoleStudentList()
    .then((res) => {
      if (res?.status === 200) {
        if (res?.data && res?.data?.list && res?.data?.list.length > 0) {
          let studentArr = res?.data?.list || [];
          setStudentList(studentArr);
          setStudentId(studentArr[0]?.id);
          setLoading(false);
        }
      }
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const handleChangeStudent = (e) => {
    setStudentId(e.target.value);
    setLoading(true); // Show loader immediately when student changes
  };

  useEffect(() => {
    if (studentList && studentList.length > 0 && studentId) {
      getParentladders();
    }
  }, [studentList, studentId]);

  const getParentladders = () => {
    let payload = {
      studentid: studentId || ""
    };
    setLoading(true);
    LaddersDataService.getParentRoleLadders(payload)
    .then((res) => {
      if (res?.status === 200) {
        if (res?.data) {
          let chekedObj = res?.data?.message[0] || {};
          let tagVal = res?.data?.profile_quote || "";
          setCheckListObj(chekedObj);
          setTagline(tagVal);
          setLoading(false);
        }
      }
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const checklistItems = [
  {
    id: 1,
    text: t('collegeEnrollmentLadders'),
    isChecked: checkListObj.complete_all || false
  },
  {
    id: 2,
    text: t('completeFafsa'),
    isChecked: checkListObj.fafsa || false
  },
  {
    id: 3,
    text: t('providedRecommendations'),
    isChecked: checkListObj.p_recom || false
  },
  {
    id: 4,
    text: t('completedCollegeEssay'),
    isChecked: checkListObj.essay || false
  },
  {
    id: 5,
    text: t('submittedTranscript'),
    isChecked: checkListObj.transcript || false
  },
  {
    id: 6,
    text: t('paidApplicationFees'),
    isChecked: checkListObj.paid_fee || false
  }];


  return (
    <>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner parentLadder">
            {/* Header Section with Google Ad */}
            <div className="ladder-ad-header">
              <div className="header-content">
                {/* Google Ad Section - Centered */}
                <div className="ad-section-centered">
                  <Advert />
                </div>
              </div>
            </div>

            <div className="checklist-container">
              <Row>
                <Col lg="12">
                  <h3 className="checklist-title">{t('collegeChecklist')}</h3>
                </Col>
              </Row>
              {studentList && studentList.length > 0 &&
              <Row>
                  <Col lg="12">
                    <FormGroup className="text-left studentSelect">
                      <Label className="child-select-label">{t('selectYourChild')}</Label>
                      <Input
                      className="form-control"
                      type="select"
                      name="studentId"
                      value={studentId || ""}
                      onChange={handleChangeStudent}>
                      
                        {studentList.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                              {item.name}
                            </option>);

                      })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>}
              
              <Row>
                <Col lg="12" className="mx-auto">
                  {loading ?
                  <div className="loading-container">
                      <Loading />
                    </div> :

                  <div className="checklist-items">
                      {checklistItems.map((item) =>
                    <div key={item.id} className="checklist-item">
                          <span className="item-text">{item.text}</span>
                          <div className="check-icon-wrapper">
                            <img
                          src={item.isChecked ? checkIcon : unCheckIcon}
                          alt={item.isChecked ? t('checked') : t('unchecked')}
                          className="check-icon" />
                        
                          </div>
                        </div>
                    )}
                    </div>}
                  
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default ParentLadder;